import { ParamsList } from '../../validator/shared';

const paramsList: ParamsList = [
    { keyName: 'canonicalUrl', isRequired: true },
    { keyName: 'deviceType', isRequired: true },
    { keyName: 'gaPageType', isRequired: true },
    { keyName: 'priceInPence', isRequired: true },
    { keyName: 'imageUrl', isRequired: false },
    { keyName: 'sellerType', isRequired: false },
    { keyName: 'encryptedVrnCarMoney', isRequired: false },
    { keyName: 'mileageValue', isRequired: false },
    { keyName: 'accountId', isRequired: false },
    { keyName: 'l1Category', isRequired: false },
    { keyName: 'l2Category', isRequired: false },
];

export default paramsList;
